import {
  getBookkeepingAccounts,
  getBookkeepingIntegration,
  getVouchers,
  retryVoucher,
} from '../../api/admin';
import invalidationManager from './InvalidationManager';
import BookkeepingAccount from '../../model/BookkeepingAccount';
import { VoucherHistory } from '../../model/BookkeepingVoucher';

export interface BookkeepingIntegration {
  bookkeeper: string;
}

const { hook: useBookkeepingAccounts } = invalidationManager.createFetcher({
  queryKey: (companyId: string) => ['company', companyId, 'bookkeepingAccounts'],
  fetchFunction: async (companyId: string): Promise<BookkeepingAccount[]> => {
    return getBookkeepingAccounts(companyId);
  },
});

const { hook: useBookkeepingIntegration } = invalidationManager.createFetcher({
  queryKey: (companyKey: string) => ['company', companyKey, 'bookkeepingIntegration'],
  fetchFunction: async (companyKey: string): Promise<BookkeepingIntegration | null> => {
    return getBookkeepingIntegration(companyKey);
  },
});

const { hook: useVouchers } = invalidationManager.createInfiniteFetcher({
  queryKey: (companyKey: string, offset = 0) => ['company', companyKey, 'vouchers', String(offset)],
  fetchFunction: async (offset: number, companyKey: string): Promise<VoucherHistory[]> => {
    return getVouchers(companyKey, offset).then((res) => res.vouchers);
  },
});

const useRetryVoucherMutation = invalidationManager.createMutationHook({
  mutationFunction: async ({
    companyKey,
    voucherKey,
  }: {
    companyKey: string;
    voucherKey: string;
  }) => {
    return retryVoucher(companyKey, voucherKey);
  },
});

export { useBookkeepingAccounts, useBookkeepingIntegration, useVouchers, useRetryVoucherMutation };
